export const AUTHENTICATING = "AUTHENTICATING";
export const AUTHENTICATED = "AUTHENTICATED";
export const LOGOUT = "LOGOUT";
export const AUTHEN_ERROR = "AUTHEN_ERROR";